import { z } from 'zod'

const dateString = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Date must be YYYY-MM-DD')

export const documentFormSchema = z
  .object({
    title: z.string().min(1, 'Title is required'),
    version: z.string().min(1, 'Version is required'),
    content: z.string(),
    eorp_section: z.string(),
    effective_start_date: dateString,
    effective_end_date: dateString,
    is_active: z.boolean(),
  })
  .refine((v) => v.effective_end_date >= v.effective_start_date, {
    message: 'End date must be on or after start date.',
    path: ['effective_end_date'],
  })

export type DocumentFormValues = z.infer<typeof documentFormSchema>

export const changeReasonSchema = z.object({
  note: z.string().min(1, 'Reason is required'),
})

export type ChangeReasonValues = z.infer<typeof changeReasonSchema>
